var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "20px",
    viewBox: "0 0 40 20",
    enableBackground: "new 0 0 40 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 40,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.75,
    d: "M20,1.875C12.85,1.875,6.449,5.051,2.158,10 C6.449,14.949,12.85,18.125,20,18.125c7.15,0,13.551-3.176,17.842-8.125C33.551,5.051,27.15,1.875,20,1.875z"
  }), /*#__PURE__*/React.createElement("circle", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.25,
    cx: 20,
    cy: 10,
    r: 7.875
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    d: "M20,13.5c1.933,0,3.5-1.567,3.5-3.5c0-1.933-1.567-3.5-3.5-3.5c-1.933,0-3.5,1.567-3.5,3.5 C16.5,11.933,18.067,13.5,20,13.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuge);
export default __webpack_public_path__ + "static/media/auge.950c2ce98b4c6b69a09ed2e1483a19ae.svg";
export { ForwardRef as ReactComponent };